import styled, { createGlobalStyle } from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';
import { baseVariables } from '@marriott/mi-ui-library';
import { MAP_VIEW_POINTS_PRICE_CHANGES } from '../../modules/constants';

/* Global styles for tooltip modal when rendered via portal */
export const TooltipPortalStyles = createGlobalStyle`
  .tooltip-popup-wrapper {
    max-height: ${toRem(513)};
    min-height: ${toRem(290)};
  }
  .custom-heights {
    height: auto !important;
    max-height: ${toRem(400)} !important;
    overflow-y: auto !important;
    @media only ${theme.mediaQuery.minDesktop}, ${theme.mediaQuery.desktop}, ${theme.mediaQuery.largeDesktop} {
      padding-top: ${toRem(32)} !important;
    }
    @media only ${theme.mediaQuery.allMobiles}, ${theme.mediaQuery.allTablets} {
      padding-top: ${toRem(23.5)} !important;
    }
  }
  .tooltip-main-wrapper {
    height: ${toRem(200)};
    font-size: ${toRem(16)};
    font-family: ${theme.fonts['fontFamilySwiss']};
    letter-spacing: 0;
    line-height: ${toRem(20)};
    color: ${theme.color['dark-gray-14']};
    font-weight: ${theme.fonts['fontWeightMedium']};
  }
  .tooltip-main-content {
    font-size: ${toRem(12)};
    letter-spacing: 0;
    font-family: ${theme.fonts['fontFamilySwiss']};
    line-height: ${toRem(18)};
    font-weight: ${theme.fonts['fontWeightRegular']};
    padding-top: ${toRem(16)};
    @media only ${theme.mediaQuery.allTablets} {
      padding-top: ${toRem(12)};
    }
  }
  .custom-list {
    width: 100%;
    font-family: ${theme.fonts['fontFamilySwiss']};
    padding-right: ${toRem(30)};
    font-weight: ${theme.fonts['fontWeightRegular']};
  }
  .custom-ul-props {
    column-count: 2;
    margin-inline-start: ${toRem(-10)} !important;
    margin-inline-end: ${toRem(-30)} !important;
  }
  .full-width-list {
    column-count: 1 !important;
  }
  .row-reverse {
    flex-direction: row-reverse !important;
    background: ${theme.color['alabaster']};
  }
  .custom-header-font h4 {
    font-size: ${toRem(22)};
    font-weight: ${theme.fonts['fontWeightMedium']};
    letter-spacing: 0;
    line-height: ${toRem(26)};
  }
  .popup-close-button {
    background-color: ${theme.color['gallery']};
    font-size: large;
  }

  /* Tablet styles */
  @media only ${theme.mediaQuery.allTablets} {
    .tooltip-popup-wrapper {
      max-height: ${toRem(640)};
      min-height: ${toRem(293)};
    }
    .custom-ul-props {
      column-count: 1;
    }
    .custom-list {
      padding-left: ${toRem(10)};
    }
    .popup-close-button {
      font-size: x-large;
      height: ${toRem(32)};
      width: ${toRem(32)};
    }
    .popup-width {
      width: ${toRem(584)};
    }
    .custom-header-font h4 {
      font-size: ${toRem(22)};
      font-weight: ${theme.fonts['fontWeightMedium']};
      letter-spacing: 0;
      line-height: ${toRem(26)};
    }
  }

  /* Mobile styles */
  @media only ${theme.mediaQuery.allMobiles} {
    .tooltip-popup-wrapper {
      max-height: ${toRem(760)};
      min-height: ${toRem(310)};
      margin-top: 0;
    }
    .custom-ul-props {
      column-count: 1;
    }
    .custom-list {
      padding-left: ${toRem(10)};
    }
    .custom-header-font h4 {
      font-size: ${toRem(18)};
      font-weight: ${theme.fonts['fontWeightMedium']};
      letter-spacing: 0;
      line-height: ${toRem(20)};
    }
    .custom-header-font {
      height: ${toRem(92.5)};
    }
    .custom-position {
      top: unset;
    }
    .popup-width {
      width: inherit;
    }
    .row-reverse {
      background: ${theme.color['alabaster']};
    }
  }
`;

/* stylelint-disable value-no-vendor-prefix, property-no-vendor-prefix */
export const Styled = styled.div`
  ${rtl`
  /* CSS-reactive typography classes (mobile-first, desktop at lg breakpoint) */
  /* Note: Using explicit rem values since t-font-alt-* CSS variables don't exist */
  /* lg breakpoint (min-width: 992px) matches original getBreakpoint() logic where >991 = desktop */

  .card-fs-s-to-xs {
    font-size: ${toRem(12)};
    line-height: ${toRem(18)};
    @media ${baseVariables.mediaQuery.lg} {
      font-size: ${toRem(14)};
      line-height: ${toRem(21)};
    }
  }

  .card-fs-m-to-s {
    font-size: ${toRem(14)};
    line-height: ${toRem(20)};
    @media ${baseVariables.mediaQuery.lg} {
      font-size: ${toRem(16)};
      line-height: ${toRem(24)};
    }
  }

  .card-title-ellipses-responsive {
    @media ${theme.mediaQuery.allMobiles} {
      &.title-ellipses {
        display: none;
      }
      &::after {
        content: '';
      }
    }
  }

  .card-title-secondary-responsive {
    @media ${theme.mediaQuery.allMobiles} {
      font-size: ${toRem(16)};
      line-height: ${toRem(22)};
    }
  }

  /* Title responsive: m (16px) on mobile/tablet, xl (22px) on desktop */
  .card-title-xl-to-m {
    font-size: ${toRem(16)};
    line-height: ${toRem(20)};
    @media ${baseVariables.mediaQuery.lg} {
      font-size: ${toRem(22)};
      line-height: ${toRem(26)};
    }
  }

  .la-county-section-list-view {
    padding-right:${toRem(2)};
  }
   .points-saver {
     .price-section-color {
       justify-content:flex-start;
     }
   }

   .title-primary {
    @media ${baseVariables.mediaQuery.md} {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    @media ${baseVariables.mediaQuery.lg} {   
      -webkit-box-orient: unset;
      font-size: ${toRem(18)};
      line-height: ${toRem(24)};
    }
   }
    
   .title-primary-mob {
      max-height: ${toRem(42)} !important;
      text-overflow: ellipsis;
      overflow-y: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .title-secondary-mob,.title-primary-mob-map {
      max-height: ${toRem(32)} !important;
      text-overflow: ellipsis;
      overflow-y: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .text-descriptor{
      color: ${baseVariables?.color?.neutral40};
      font-size: ${baseVariables?.font.fontM}
      @media ${baseVariables.mediaQuery.md} {
        font-size: ${baseVariables?.font.fontL}
      }
      @media ${baseVariables.mediaQuery.lg} {
        font-size: ${baseVariables?.font.fontXxl}
      }
    }
   @media ${baseVariables.mediaQuery.md} {
    .title-ellipses {
      width: ${toRem(320)} !important;
      text-overflow: ellipsis;
      overflow:hidden;
      white-space: nowrap;
    }
    .fee-title-ellipses {
      Max-width: calc(100% - ${toRem(44)});
      text-overflow: ellipsis;
      overflow:hidden;
      white-space: nowrap;
    }
   }
   @media ${baseVariables.mediaQuery.lg} {
    .title-ellipses {
      width: ${toRem(572)} !important;
      text-overflow: ellipsis;
      overflow:hidden;
      white-space: nowrap;
    }
    .fee-title-ellipses {
      max-width: calc(100% - ${toRem(44)});
      text-overflow: ellipsis;
      overflow:hidden;
      white-space: nowrap;
    }
   }

  @media only ${theme.mediaQuery.allTablets} {
    .description-ellipsis {
      white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
  width:41vw;
  display:block !important;
    }
  }
  .points-currency-label {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .flexi-opening-soon {
    > div {
      padding-left: ${toRem(4)};
    }
    text-align:end;
      @media only ${theme.mediaQuery.tablet} {
        display:flex;
      }
  }
  .opening-soon-font{
    font-size: ${toRem(14)};
  }
  .map-view-show-availability {
    display:flex;
    flex-direction: column;
    max-width:${toRem(130)};
  }
  .map-view-show-availability-text{
    text-align:right;
  }
  .view-availability-section {
    margin-left:${toRem(26)};
  }
  .mandatory-fee-section{
      font-size:${toRem(12)};
      margin-top: ${toRem(-8)};
      line-height:${toRem(16)};
      color: ${baseVariables?.color?.base10};
      padding-right:${toRem(2)};
      .custom-info-list{
        color: ${baseVariables?.color?.base10};
      }
    }
    .mandatory-fee-section-list-view{
      font-size:${toRem(12)};
      line-height:${toRem(16)};
      color: ${baseVariables?.color?.base10};
    }
    .mandatory-fee-title-wrapper{
      width: auto;
    }
  .price-section-color{
    color: ${theme.color['dark-gray-13']};
    width: 100%;
    justify-content: flex-start;
  }
  .includes-fee{
    display:flex;
    justify-content: flex-end;
    margin-right: ${toRem(3)};
  }
  .distance-section {
    display:flex;
  }
  .price-sub-section-chat{
    width: 100% !important;
  }
  .price-sub-section{
    display:block;
    overflow: visible;
     @media ${baseVariables.mediaQuery.md}{
        width: 50%
     }
     @media ${baseVariables.mediaQuery.lg}{
        width: unset;
     }
  }
  .custom-info-map{
    font-size:${toRem(12)};
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
    justify-content : flex-end;
    pointer-events:none;
    color:inherit;
    line-height: 1;
  }
  .mandatory-fee-section,
  .mandatory-fee-section-list-view{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .mandatory-fee-section-chat{
    justify-content: flex-end;
    width: 100%;
  }
  .mandatory-fee-section-list-view{
    justify-content: flex-start;

  }
  .mandatory-fee-section-map-view{
    justify-content: flex-start;
    @media ${baseVariables.mediaQuery.lg}
          {
              justify-content: flex-end;
          }
  }
  .mandatory-fee-section-list-view .mandatory-fee-title-wrapper{
    width: auto !important;
    flex: 0 0 auto !important;
    justify-content: flex-start !important;
  }
  .mandatory-fee-label-text{
    display: inline-block;
  }
  .mandatory-fee-section .m-link-icon-button-info,
  .mandatory-fee-section-list-view .m-link-icon-button-info{
    vertical-align: middle;
    display: inline-flex;
    align-items: center;
    line-height: 1;
    &.mandatory-fee-icon-offset{
      margin-top: ${toRem(-4)};
      margin-left: ${toRem(-4)};
    }
  }
  .mandatory-fee-section .m-link-icon-button-info:after,
  .mandatory-fee-section-list-view .m-link-icon-button-info:after{
    vertical-align: middle;
    display: inline-block;
  }

  .m-link-icon-button-info:hover{
    background-color:transparent !important ;
    cursor: pointer !important ;
  }

  .remove-info-icon:{
    :after{
     content:none !important;
    }
  }
  .custom-info-list{
    pointer-events:none;
    vertical-align: middle;
    display: inline-flex;
    align-items: center;
    line-height: 1;
  }
  .custom-info-list:after{
    pointer-events:all;
    height:${toRem(13.33)};
    width:${toRem(13.33)};
    vertical-align: middle;
    display: inline-block;
  }
  .custom-info-map:after{
    height:${toRem(13.33)};
    width:${toRem(13.33)};
    pointer-events:all;
    vertical-align: middle;
    display: inline-block;
  }

  .property-card-container {
    border-radius: ${toRem(14)};
    overflow: hidden;
    height: ${toRem(285)};
    margin: ${toRem(8)} 0 ${toRem(16)} 0 ;
    font-family: ${theme.fonts['fontFamilySwiss']};
    display: flex;
    flex-direction: row;
    @media only ${theme.mediaQuery.allTablets}{
      min-width: ${toRem(1124)};
    }
    /* box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.14); */
    box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0,0,0,0.07);
    .image-gallery-container {
      width: 45%;
      @media only ${theme.mediaQuery.allTablets}{
        width: ${toRem(360)};
        .brand-logo-MG::before {
          font-size: ${toRem(30)} !important;
        }
      }
      .hotel-image-container {
        width: 100%;
        height: 100%;
        .property-image {
          width: 100%;
          height: 100%;
          /* border-radius: ${toRem(8)} 0 0 ${toRem(8)}; */
        }
      }
      .hotel-brand-logo-container{
        left: 0 !important;
      }
      .hotel-brand-container {
        position: relative;
        bottom: ${toRem(78)};
        left: ${toRem(16)};
        width: ${toRem(124)};
        min-height: ${toRem(60)};
        background-color: transparent;
        display: flex;
        align-items: flex-end;
        border-radius: ${toRem(4)};
        .brand-logo-container {
          background: transparent;

          @media only ${theme.mediaQuery.allMobiles} {
            padding-bottom: ${toRem(2)};
          }
        }
        .brand-logo-SH::before {
          font-size: ${toRem(35)};
        }
        .brand-logo-GE::before {
          font-size: ${toRem(39)};
        }
        .brand-logo-AR::before {
          font-size: ${toRem(45)};
        }
        .brand-logo-AL::before {
          font-size: ${toRem(39)};
        }
        .brand-logo-AK::before {
          font-size: ${toRem(35)};
        }
        .brand-logo-CY::before {
          font-size: ${toRem(15)};
        }
        .brand-logo-DE::before {
          font-size: ${toRem(46)};
        }
        .brand-logo-DS::before {
          font-size: ${toRem(10)};
        }
        .brand-logo-EB::before {
          font-size: ${toRem(16)};
        }
        .brand-logo-EL::before {
          font-size: ${toRem(40)};
        }
        .brand-logo-FI::before {
          font-size: ${toRem(19)};
        }
        .brand-logo-FP::before {
          font-size: ${toRem(33)};
        }
        .brand-logo-JW::before {
          font-size: ${toRem(42)};
        }
        .brand-logo-MD::before {
          font-size: ${toRem(16)};
        }
        .brand-logo-ER::before {
          font-size: ${toRem(40)};
        }
        .brand-logo-MI::before {
          font-size: ${toRem(33)};
        }
        .brand-logo-MV::before {
          font-size: ${toRem(39)};
        }
        .brand-logo-MC::before {
          font-size: ${toRem(33)};
        }
        .brand-logo-OX::before {
          font-size: ${toRem(27)};
        }
        .brand-logo-PR::before {
          font-size: ${toRem(40)};
        }
        .brand-logo-BR::before {
          font-size: ${toRem(42)};
        }
        .brand-logo-RI::before {
          font-size: ${toRem(20)};
        }
        .brand-logo-SI::before {
          font-size: ${toRem(40)};
        }
        .brand-logo-XR::before {
          font-size: ${toRem(38)};
        }
        .brand-logo-LC::before {
          font-size: ${toRem(43)};
        }
        .brand-logo-RZ::before {
          font-size: ${toRem(40)};
        }
        .brand-logo-TS::before {
          font-size: ${toRem(32)};
        }
        .brand-logo-TX::before {
          font-size: ${toRem(20)};
        }
        .brand-logo-WH::before {
          font-size: ${toRem(14)};
        }
        .brand-logo-WI::before {
          font-size: ${toRem(20)};
        }
        .brand-logo-XE::before {
          font-size: ${toRem(31.2)};
          margin-top: ${toRem(17)};
        }
        .brand-logo-MG::before {
          font-size: ${toRem(35)};
        }
        .brand-logo-BA::before {
          font-size: ${toRem(47)};
        }
        .brand-logo-XF::before {
          font-size: ${toRem(34.6)};
        }
        .brand-logo-BG::before {
          font-size: ${toRem(22.4)};
        }
        .brand-logo-RS {
          display: flex;
          margin-bottom: ${toRem(14)};
        }
        .brand-logo-RS::before {
          font-size: ${toRem(25)};
          line-height: ${toRem(10)};
        }
        .brand-logo-SN::before {
          font-size: ${toRem(50)};
          margin-left: ${toRem(-10)};
        }
      }
    }
    .text-container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 55%;
      border-radius: 0 ${toRem(14)} ${toRem(14)} 0;
      @media only ${theme.mediaQuery.allMobiles} {
        border-radius: 0 0 ${toRem(14)} ${toRem(14)};
      }
      @media only ${theme.mediaQuery.allTablets} {
        width: calc(100% - ${toRem(360)});
      }
      .horizontal-line {
        width: 100%;
        border-top: ${toRem(1)} solid ${theme.color['gallery']};
      }

      .edge-case {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin: ${toRem(12)} ${toRem(16)};
        width: 100%;
        @media ${baseVariables.mediaQuery.md}
          {
            margin: ${toRem(12)} ${toRem(16)};
            width:auto;
          }
        @media ${baseVariables.mediaQuery.lg}
          {
            margin: ${toRem(16)} ${toRem(24)};
            display: flex;
            justify-content: flex-end;
            width:auto;
          }
        &.hotel-unavailable {
          width: calc(100% - ${toRem(24)});
          margin-left: ${toRem(24)};
          display: flex !important;
          justify-content: space-between;
          @media ${baseVariables.mediaQuery.lg}
          {
              display: flex;
              justify-content: flex-end;
          }
        }
          .cta-button {
            margin-left: ${toRem(24)};
            .show-availability-button {
              border: ${toRem(2)} solid ${theme.color['cod-grey']};
              white-space: nowrap;
              &:focus {
                outline: none;
              }
            }
          }
        }
      }
      .edge-case{
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        margin-top: ${toRem(16)};
        margin-bottom: ${toRem(16)};
        margin-left: ${toRem(16)};
        margin-right: ${toRem(22)};
        &.adult-only-property {
          display: block;
          text-align: left;
          @media only ${baseVariables.mediaQuery.lg} {
            text-align: right;
          }
          .adult-only-message {
            display: inline;
          }
          .remove-children-message {
            display: inline;
          }
          &.adult-edge-case-de{
            display:flex;
            flex-direction: column;
            @media only ${theme.mediaQuery.allTablets} , ${theme.mediaQuery.desktop}
          {
            align-items:flex-end;
          }
          }

          .remove-children-message {
            padding-left: ${toRem(2)};
          }
        }
      }
      .details-container {
        margin-left: ${toRem(16)};
        margin-right: ${toRem(16)};
        height: ${toRem(185)};
        display: flex;
        flex-direction: column;
        max-width:fit-content;
        justify-content:space-around;

        @media only ${theme.mediaQuery.allTablets} {
          height: auto;
          max-width: ${toRem(713)};
        }
        @media only ${theme.mediaQuery.allMobiles} {
          height: auto;
        }
        @media ${baseVariables.mediaQuery.lg} {
          margin-left: ${toRem(24)};
          margin-right: ${toRem(24)};
        }
        .title-container {
          margin-top: ${toRem(12)};
          width: fit-content;
          background: ${theme.color['white']};
          text-align: left;
          padding-left: ${toRem(0)};
        }
        .description-container {
          @media ${baseVariables.mediaQuery.lg} {
            text-overflow: ellipsis;
            overflow: hidden;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            display: -webkit-box;
          }
        }
         .title-container:focus-visible:not(:active){
           outline: -webkit-focus-ring-color auto 1px;
         }
         .title-container: focus{
          outline:none;
         }
        .reviews-distance-container {
          display: flex;
          flex-direction: row;
          align-items: center;
          color: ${theme.color['dove-grey']};
          font-weight: ${theme.fonts['fontWeightRegular']};
          .divider-section {
            display: flex;
            align-items: center;
          }
          .hqv-modal-opener {
            background: transparent;
          }
          .rating-container {
            border-bottom: ${toRem(0.5)} solid ${theme.color['white']};
            margin-bottom: ${toRem(-0.5)};
            padding-left: ${toRem(0)};
            display: flex;
            flex-direction: row;
            font-weight: ${theme.fonts['fontWeightRegular']};
            .star-container {
            &:dir(rtl) {
                margin-right: ${toRem(4)};
              }
              display: flex;
              flex-direction: row;
              padding: 0;
              .ratings-value-container {
                align-items: center;
                .star-icon-container:before {
                  line-height: 2;
                  .star-number-container{
                    margin-right:${toRem(7)};
                  }
                }
                .review-number-container {
                  &.text-overflow-ellipsis {
                    max-width: ${toRem(112)};
                  }
                }
                .reviews-count-container{
                  width: 80%;
                  overflow:hidden;
                  text-overflow:ellipsis;
                  white-space:nowrap;
                  @media ${baseVariables.mediaQuery.md}{
                    display: none;
                  }
                  @media ${baseVariables.mediaQuery.lg}{
                    display: block;
                  }
                }  
                .review-ellipsis{
                  max-width:12ch;
                  overflow:hidden;
                  text-overflow:ellipsis;
                  white-space:nowrap;
                }

              }
            }
            &:hover {
              border-bottom: ${toRem(0.5)} solid ${theme.color['dove-grey']};
              margin-bottom: ${toRem(-0.5)};
            }
            @media ${baseVariables.mediaQuery.lg} {   
              font-size: ${toRem(12)};
              line-height: ${toRem(18)};
            }
          }
          .rating-container.is-review-count-hidden {
            &:hover {
              border-bottom: none;
                }
          }
          .rating-container:focus-visible:not(:active){
            outline: -webkit-focus-ring-color auto 1px;
          }
          .rating-container: focus{
           outline:none;
          }
          .chat-distance-section {
            max-width: 47%;
            .chat-distance-container {
              max-width: 100%;
            }
          }

          .distance-container {
            display: flex;
            flex-direction: row;
            .from-destination-label {
              margin-left: ${toRem(4)};
            }
            .distance-value {
              margin-left: ${toRem(4)};
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              &.text-overflow-ellipsis {
                max-width:${toRem(117)};
              }
            }
            .chat-distance-ellipsis {
              max-width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .distance-ellipsis {
              max-width:23ch;
              overflow:hidden;
              text-overflow:ellipsis;
              white-space:nowrap;
            }
          }
          .distance-container:focus-visible:not(:active){
            outline: -webkit-focus-ring-color auto 1px;
          }
          .distance-container: focus{
           outline:none;
          }

          @media ${baseVariables.mediaQuery.lg} {   
              font-size: ${toRem(12)};
              line-height: ${toRem(18)};
          }
        }
          .property-card-all-inclusive-tag{
            background: ${theme.color['dark-gray-4']};
            border-radius: ${toRem(4)};
            height: ${toRem(16)};
            letter-spacing: ${toRem(1.2)};
            text-transform: uppercase;
            width: fit-content;
            white-space: nowrap;
            @media ${baseVariables.mediaQuery.md}{
              margin-right: ${toRem(8)};
            }
          }
        .description-container:focus-visible:not(:active){
          outline: -webkit-focus-ring-color auto 1px;
        }
        .description-container: focus{
         outline:none;
        }
        .view-hotel-details-section {
          background: transparent;
          width: fit-content;
          padding-left: ${toRem(0)};
          padding-top: ${toRem(8)};
          .icon-holder {
            font-size: ${toRem(18)};
            margin-top: ${toRem(-4)};
          }
        }
      }
      .chat-details-container {
        gap: ${toRem(8)};
      }
      .lower-section{
        @media only ${theme.mediaQuery.allMobiles} {
        height: fit-content;
        }
      }
      .view-hotel-details-section:focus-visible:not(:active){
       outline: -webkit-focus-ring-color auto 1px;
      }
      .view-hotel-details-section: focus{
       outline:none;
      }
      .price-container {
        display: flex;
        flex-direction: row;
        justify-content:space-between;
        align-items: center;
        min-height: ${toRem(40)};
        margin: ${toRem(9)} ${toRem(16)};
        @media ${baseVariables.mediaQuery.md}
          {
              margin-left: ${toRem(16)};
              margin-right: ${toRem(16)};
          }
        @media ${baseVariables.mediaQuery.lg}
          {
              margin-left: ${toRem(24)};
              margin-right: ${toRem(24)};
              display: flex;
              justify-content: flex-end;
          }
        &.price-de-container-map-view {
          margin-left: ${toRem(8)};
          margin-right: ${toRem(10)};
        }
        &.price-container-for-flexible-date{
          display: flex;
          justify-content: flex-end !important;
        }
        
        .property-card-price-component{
          .rate-container {
            justify-content:flex-start;
            display: flex;
            flex-direction: row;
            align-items: baseline;
            @media ${baseVariables.mediaQuery.lg} {
              display: flex;
              justify-content: flex-start;
            }
            .currency-label {
              margin-left: ${toRem(8)};
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .amount-display {
              &:dir(rtl) {
                display: flex;
                align-items: baseline;
                float: right;
                flex-direction: row;
              }
            }
            .ru-specific-price-section {
                display: flex;
                align-items: start;
                flex-direction: column;
                .ru-specific-line-height {
                  line-height: ${toRem(21)};
                }
            }
            .idr-currency-label{
              padding-bottom: ${toRem(4)};
              margin-left: ${toRem(5)};
              @media only ${theme.mediaQuery.allMobiles} {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
            .idr-currency-label-map{
              margin-left: ${toRem(0)} !important;
            }
            .taxes-and-fees-section {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              .price-section {
                display: flex;
                flex-direction: row;
                align-items: baseline;
                justify-content: flex-end;
                &.points-value-de-section {
                  flex-direction: row;
                  flex-wrap: wrap;
                  justify-content: flex-end;
                }
              }
              .taxes-and-fees-included {
                font-family: "Swiss-721";
                margin-top: ${toRem(-4)};
              }
            }
            .points-section {
              display: flex;
              flex-direction: column;
              width: 100%;
              .points-saver-label {
                margin-bottom: ${toRem(-2)};
                align-self: start;
              }
              .ru-specific-price-section {
                display: flex;
                align-items: start;
                flex-direction: column;
                .ru-specific-line-height {
                  line-height: ${toRem(21)};
                }
              }
              .price-section {
                display: flex;
                flex-direction: row;
                align-items: baseline;
                line-height: ${toRem(20)};
                width: 100%;
                column-gap: ${toRem(8)};
                &.points-value-de-section {
                  flex-direction: row;
                  flex-wrap: wrap;
                  justify-content: flex-end;
                }
                .points-value {
                  &.points-saver {
                    color: ${theme.color['verdun-green']};
                    
                  }
                }

                .points-currency-label {
                  margin-right: ${toRem(6.4)};
                  padding-bottom: ${toRem(4)};
                }

              }
              &.non-saver {
                align-items: flex-start;
                .currency-section {
                  align-self: start;
                  text-align: left;
                  align-items: flex-start;
                }
                .price-section {
                  &:is(${MAP_VIEW_POINTS_PRICE_CHANGES}) {
                    flex-wrap: wrap;
                  }
                  justify-content: flex-start;
                  column-gap: ${toRem(8)};
                }
              }
              &.points-saver {
                .currency-section {
                  align-self: start;
                  text-align: left;
                }
                .points-currency-label {
                  color: ${theme.color['black']};
                }
              }
              .currency-section {
                margin-top: ${toRem(-2.4)};
                display: flex;
                flex-direction: row;
                align-items: baseline;
                justify-content: flex-start;
                &.points-de-currency-section {
                  width:100%;   
                }
                .currency-label {
                  margin-left: ${toRem(8)};
                }
              }
            }
          }
        }
        .view-rates-button-container {
          margin-left: ${toRem(24)};
          width: auto;

          .view-rates-button {
            width: 100%;

            &:focus {
              outline: none;
            }
          }
        }
      }
    }
  }
  .map-view {
    width: ${toRem(332)};
    min-width: ${toRem(332)};
    margin:${toRem(8)} 0 ${toRem(16)} 0;
    height: auto;
    padding: 0;
    border: ${toRem(1)} solid ${theme.color['gallery']};
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.07);
    flex-direction: column;
    .image-gallery-container {
      width: 100%;
      position: relative;
      .hotel-brand-container {
        align-items: flex-end;
        position: absolute;
        bottom: ${toRem(11)};
        margin-left: ${toRem(0)};
        .brand-logo-SH::before {
          font-size: ${toRem(35)};
        }
        .brand-logo-GE::before {
          font-size: ${toRem(39)};
        }
        .brand-logo-AR::before {
          font-size: ${toRem(39)};
        }
        .brand-logo-AL::before {
          font-size: ${toRem(39)};
        }
        .brand-logo-AK::before {
          font-size: ${toRem(35)};
        }
        .brand-logo-CY::before {
          font-size: ${toRem(15)};
        }
        .brand-logo-DE::before {
          font-size: ${toRem(59)};
        }
        .brand-logo-DS::before {
          font-size: ${toRem(10)};
        }
        .brand-logo-EB::before {
          font-size: ${toRem(16)};
        }
        .brand-logo-EL::before {
          font-size: ${toRem(40)};
        }
        .brand-logo-FI::before {
          font-size: ${toRem(19)};
        }
        .brand-logo-FP::before {
          font-size: ${toRem(33)};
        }
        .brand-logo-JW::before {
          font-size: ${toRem(21)};
        }
        .brand-logo-MD::before {
          font-size: ${toRem(16)};
        }
        .brand-logo-ER::before {
          font-size: ${toRem(40)};
        }
        .brand-logo-MI::before {
          font-size: ${toRem(23)};
        }
        .brand-logo-MV::before {
          font-size: ${toRem(39)};
        }
        .brand-logo-MC::before {
          font-size: ${toRem(33)};
        }
        .brand-logo-OX::before {
          font-size: ${toRem(27)};
        }
        .brand-logo-PR::before {
          font-size: ${toRem(40)};
        }
        .brand-logo-BR::before {
          font-size: ${toRem(42)};
        }
        .brand-logo-RI::before {
          font-size: ${toRem(20)};
        }
        .brand-logo-SI::before {
          font-size: ${toRem(40)};
        }
        .brand-logo-XR::before {
          font-size: ${toRem(38)};
        }
        .brand-logo-LC::before {
          font-size: ${toRem(43)};
        }
        .brand-logo-RZ::before {
          font-size: ${toRem(40)};
        }
        .brand-logo-TS::before {
          font-size: ${toRem(32)};
        }
        .brand-logo-TX::before {
          font-size: ${toRem(20)};
        }
        .brand-logo-WI::before {
          font-size: ${toRem(20)};
        }
        .brand-logo-XE::before {
          font-size: ${toRem(31.2)};
          margin-top: ${toRem(17)};
        }
        .brand-logo-MG::before {
          font-size: ${toRem(22)};
        }
        .brand-logo-BA::before {
          font-size: ${toRem(42)};
        }
        .brand-logo-RS::before {
          font-size: ${toRem(25)};
          line-height: ${toRem(4)};
        }
        .brand-logo-XF::before {
          font-size: ${toRem(27.3)};
        }
        .brand-logo-BG::before {
          font-size: ${toRem(22.4)};
        }
        .brand-logo-SN::before {
          font-size: ${toRem(50)};
          margin-left: ${toRem(-15)};
        }
      }
    }
    .text-container {
      margin: 0;
      width: 100%;
      z-index: 1;
      border-radius: 0 0 ${toRem(14)} ${toRem(14)};
      .horizontal-line {
        border-top: ${toRem(1.5)} solid ${theme.color['gallery']};
      }
      .details-container {
        margin: 0 ${toRem(16)};
        height: auto;
        .title-container {
          margin-top: ${toRem(12)};
        }
        .description-container {
          display: none;
        }
        .view-hotel-details-section {
          margin-top: ${toRem(0)};
          margin-bottom: ${toRem(8)};
          .icon-holder {
            .icon-forward-arrow {
              font-size: ${toRem(16)};
              margin-top: ${toRem(1)};
              margin-left: ${toRem(-3)};
            }
          }
        }
      }
      .price-container {
        margin-left: ${toRem(16)};
        margin-right: ${toRem(16)};
        margin-bottom: ${toRem(10)};
        margin-top: ${toRem(10)};
        display: flex;
        justify-content: space-between;
        .rate-container {
          color: ${theme.color['black']};
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: flex-start;
          .currency-label {
            margin-left: ${toRem(8)};
          }
          .idr-currency-label{
            margin-left: ${toRem(8)};
          }
          .points-section {
            &.non-saver {
              align-items: flex-start;
            }
          }
          .price-section-display-block {
                display:block !important;
              }
          .taxes-and-fees-included {
              margin-top: ${toRem(-2.4)};
            }
          .taxes-and-fees-section {
            .price-section {
              padding-bottom: ${toRem(4)};
              justify-content: flex-end;
              .currency-label {
                font-size: ${toRem(10)};
                margin-left: ${toRem(8)};
              }
            }
            .taxes-and-fees-included {
              font-size: ${toRem(12)};
            }
          }
        }
        .view-rates-button-container {
          flex-shrink: 0;
          margin-left: ${toRem(20)};
        }
      }
      .adult-only-edge-cases{
        &.adult-edge-case-de{
          display:flex;
          flex-direction: column;
          align-self:flex-start;
          @media only ${baseVariables.mediaQuery.lg} {
            align-self:flex-end;
          }
        }
        .adult-only-property {
          display:block;
          margin-left: ${toRem(16)};
          margin-top: ${toRem(10)};
          margin-bottom: ${toRem(10)};
          margin-right: ${toRem(10)};
          font-size: ${toRem(14)};
          .adult-only-message{
            align-self:center;
            display: inline;
          }
          .remove-children-message {
            display: inline;
          }
      }
    }
      .edge-cases {
        display: flex;
        justify-content: space-between;
          @media ${baseVariables.mediaQuery.lg}
          {
              display: flex;
              justify-content: flex-end;
          }
        .edge-case {
          display: flex;
          justify-content: flex-start;
          width:100%;
           @media ${baseVariables.mediaQuery.lg}
          {
              display: flex;
              justify-content: flex-end;
          }
          &.opening-soon {
            white-space: nowrap;
            > span {
              display: flex;
              gap: 5px;
              text-wrap: wrap;
              text-align: left;
            }
            margin: ${toRem(16)};
            span {
              display: flex;
              gap: 5px;
            }
            &.not-bookable {
              > span {
                white-space: nowrap;
                text-align: left;
              }
              margin: ${toRem(16)};
            }
          }
          &.hotel-unavailable {
          width: 100%;
          display: flex;
          justify-content: space-between;
          margin: ${toRem(10)} 0;
            .cta-button {
              margin-left: ${toRem(24)};
            }
          }
          &.call-to-book {
            margin-bottom: ${toRem(16)};
            margin-top: ${toRem(16)};
          }

        }
      }
    }
  }
  .edge-cases-tablet-map {
    width: 100%;
    margin-left: ${toRem(16)};
    margin-right: ${toRem(16)};
  }
  .max-occupancy{
    margin-right: ${toRem(16)};
    text-align: center;
    @media only ${baseVariables.mediaQuery.lg} {
      text-align: left;
      margin-right: ${toRem(0)};
    }
    @media only ${theme.mediaQuery.allMobiles} {
      margin-left: ${toRem(16)};
    }
  }
  .map-max-occupancy{
    text-align: center;
  }
  .maximum-guest-label{
    text-align: left;
    @media ${baseVariables.mediaQuery.lg} {
      text-align: right;
      margin-left: ${toRem(0)};
    }
  }
  .max-guests {
    display: -webkit-box;        
    -webkit-box-orient: vertical; 
    -webkit-line-clamp: 2;      
    overflow: hidden;            
    text-overflow: ellipsis;
    margin-left: 0;
    text-align: left;
    @media ${baseVariables.mediaQuery.md} {
      margin-left: ${toRem(16)};
    }
    @media ${baseVariables.mediaQuery.lg} {
      padding-right: ${toRem(20)};
      padding-left: ${toRem(16)};
      display: flex;
      justify-content: flex-end;
      text-align: left;
      margin-left: ${toRem(0)};
    }
  }

  .map-max-guests{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
  }
  .edit-guest-label{
    text-align: end;
  }
  .mini-cards-fees-de {
    display: block;
  }
  @media only ${theme.mediaQuery.allTablets} {
    .custom-info-map:after{
      pointer-events: all;
      height:${toRem(13.04)};
      width:${toRem(13.04)};
    }
    .maximum-guest-label{
      text-align: end;
    }
    .edit-guest-label{
      text-align: end;
    }
    .max-occupancy{
      margin-right: 1rem;
    }
    .property-card-container {
      width: 100%;
      min-width: unset;
      margin: ${toRem(16)} 0;
      height: ${toRem(240)};
      .image-gallery-container {
        .hotel-brand-container {
          bottom: ${toRem(72)};
        }
        @media only ${theme.mediaQuery.desktop}{
          width: ${toRem(513)} ;
          }
          @media only ${theme.mediaQuery.allTablets}{
            width: ${toRem(360)};
          }
        .hotel-image-container {
          width: 100%;
          height: 100%;
          .image-gallery-component {
            .property-image {
              width: 100%;
              height: ${toRem(240)};
              .property-image--img {
                height: ${toRem(240)};
                border-radius: ${toRem(14)} 0 0 ${toRem(14)};
              }
            }
          }
        }
      }
      .only-tab-margin{
        margin-top:-9px;
      }
      .text-container {
        .details-container {
          .title-container {
            // margin-top: ${toRem(24)};
          }
          .description-container {
            margin-top: ${toRem(7)};
            font-size: ${toRem(12)};
            line-height: ${toRem(18)};
            text-overflow: ellipsis;
            overflow: hidden;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            display: -webkit-box;
          }
        }
        .price-container {
          .view-rates-button-container {
            margin-left: ${toRem(24)};
          }
          .rate-container {
            justify-content: flex-start !important;
            @media ${baseVariables.mediaQuery.lg}
              {
              display: flex;
              justify-content: flex-end;
              }
          }
        }
        .adult-only-edge-cases{
          .adult-only-property {
          flex-direction: column;
          align-items: flex-start;
          margin: ${toRem(9)} ${toRem(22)};
        }
      }
        .edge-cases {
          .edge-case {
            &.hotel-unavailable {
              display: flex;
              justify-content: space-between;
              bottom: ${toRem(8)};
              .unavailable-text {
                font-size: ${toRem(14)};
              }
            }
          }
        }
      }
    }
    .map-view-class {
      display: none;
    }
  }
  @media only ${theme.mediaQuery.allMobiles} {
    .custom-info-map:after{
      pointer-events: all;
      height:${toRem(13.04)};
      width:${toRem(13.04)};
    }

    .m-link-icon-button-info:after{
      padding-left: ${toRem(3.1)};
      padding-right: ${toRem(3.1)};
    }
    .property-card-container {
      height: auto;
      margin: 0;
      width: 100%;
      min-width: unset;
      padding: 0;
      flex-direction: column;
      .image-gallery-container {
        width: 100%;
        position: relative;
        .hotel-brand-container {
          position: absolute;
          bottom: ${toRem(12)};
          align-items: flex-end;
          margin-left: ${toRem(0)};
          .brand-logo-SH::before {
            font-size: ${toRem(35)};
          }
          .brand-logo-GE::before {
            font-size: ${toRem(39)};
          }
          .brand-logo-AR::before {
            font-size: ${toRem(39)};
          }
          .brand-logo-AL::before {
            font-size: ${toRem(39)};
          }
          .brand-logo-AK::before {
            font-size: ${toRem(35)};
          }
          .brand-logo-CY::before {
            font-size: ${toRem(15)};
          }
          .brand-logo-DE::before {
            font-size: ${toRem(59)};
          }
          .brand-logo-DS::before {
            font-size: ${toRem(10)};
          }
          .brand-logo-EB::before {
            font-size: ${toRem(16)};
          }
          .brand-logo-EL::before {
            font-size: ${toRem(40)};
          }
          .brand-logo-FI::before {
            font-size: ${toRem(19)};
          }
          .brand-logo-FP::before {
            font-size: ${toRem(33)};
          }
          .brand-logo-JW::before {
            font-size: ${toRem(35)};
          }
          .brand-logo-MD::before {
            font-size: ${toRem(16)};
          }
          .brand-logo-ER::before {
            font-size: ${toRem(40)};
          }
          .brand-logo-MI::before {
            font-size: ${toRem(23)};
          }
          .brand-logo-MV::before {
            font-size: ${toRem(39)};
          }
          .brand-logo-MC::before {
            font-size: ${toRem(33)};
          }
          .brand-logo-OX::before {
            font-size: ${toRem(27)};
          }
          .brand-logo-PR::before {
            font-size: ${toRem(40)};
          }
          .brand-logo-BR::before {
            font-size: ${toRem(42)};
          }
          .brand-logo-RI::before {
            font-size: ${toRem(20)};
          }
          .brand-logo-SI::before {
            font-size: ${toRem(40)};
          }
          .brand-logo-XR::before {
            font-size: ${toRem(38)};
          }
          .brand-logo-LC::before {
            font-size: ${toRem(43)};
          }
          .brand-logo-RZ::before {
            font-size: ${toRem(40)};
          }
          .brand-logo-TS::before {
            font-size: ${toRem(32)};
          }
          .brand-logo-TX::before {
            font-size: ${toRem(20)};
          }
          .brand-logo-WI::before {
            font-size: ${toRem(20)};
          }
          .brand-logo-XE::before {
            font-size: ${toRem(31.2)};
          }
          .brand-logo-MG::before {
            font-size: ${toRem(22)};
          }
          .brand-logo-BA::before {
            font-size: ${toRem(42)};
          }
          .brand-logo-RS::before {
            font-size: ${toRem(25)};
            line-height: ${toRem(4)};
          }
          .brand-logo-XF::before {
            font-size: ${toRem(30.1)};
          }
          .brand-logo-BG::before {
            font-size: ${toRem(22.4)};
          }
          .brand-logo-SN::before {
            font-size: ${toRem(50)};
            margin-left: ${toRem(-10)};
            margin-bottom: ${toRem(10)};
          }
        }
      }
      .text-container {
        margin: 0;
        width: 100%;
        .horizontal-line {
          border-top: ${toRem(1.5)} solid ${theme.color['gallery']};
        }
        .details-container {
          margin: 0 ${toRem(16)};
          height: auto;
          .title-container {
            margin-top: ${toRem(12)};
          }
          .description-container {
            display: none;
          }
          .view-hotel-details-section {
            margin-top: ${toRem(0)};
            margin-bottom: ${toRem(12)};
            .icon-holder {
              .icon-forward-arrow {
                font-size: ${toRem(16)};
                margin-top: ${toRem(1)};
                margin-left: ${toRem(-3)};
              }
            }
          }
        }
        .price-container__chat {
          margin-left: 0;
          margin-right: 0;
          width: 100% !important;
        }
        .price-container {
          margin-left: ${toRem(16)};
          margin-right: ${toRem(16)};
          margin-bottom: ${toRem(10)};
          margin-top: ${toRem(10)};
          width: calc(100% - ${toRem(32)});
          .rate-container {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: flex-start;
            .currency-label {
              margin-left: ${toRem(8)};
            }
            .points-section {
              &.non-saver {
                align-items: flex-start;
              }
            }

            .taxes-and-fees-section {
              .price-section {
                justify-content: flex-end;
                .currency-label {
                  font-size: ${toRem(10)};
                  margin-left: ${toRem(8)};
                }
              }
              .taxes-and-fees-included {
                font-size: ${toRem(12)};
              }
            }
          }
          .view-rates-button-container {
            flex-shrink: 0;
            margin-left: ${toRem(24)};
          }
        }

        .adult-only-edge-cases{
          .adult-only-property {
          margin: ${toRem(10)} ${toRem(16)};
          text-align: left;
          @media only ${baseVariables.mediaQuery.lg} {
            text-align: right;
          }
        }
      }

        .edge-cases {
          display: flex;
          justify-content: space-between;
          @media ${baseVariables.mediaQuery.lg}
            {
              display: flex;
              justify-content: flex-end;
            }
          .edge-case {
            &.opening-soon {
              margin-bottom: ${toRem(16)};
              margin-top: ${toRem(16)};
            }
            &.hotel-unavailable {
              margin: ${toRem(10)} 0;
              width: 100%;
              display: flex;
              justify-content: space-between;
              .cta-button {
                margin-left: ${toRem(24)};
              }
            }
            &.call-to-book {
              margin-bottom: ${toRem(16)};
              margin-top: ${toRem(16)};
            }

          }
        }
      }
    }
    .map-view-class {
      display: none;
    }
  }`}
  .disableLinks {
    pointer-events: none;
  }

  /* AI Best Match Tag Styles - Based on Figma Design */
  .ai-best-match-tag-container {
    line-height: 1;
  }

  .m-ai-best-match-tag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: ${toRem(4)};
    background: ${baseVariables?.color?.neutral5};
    border-radius: ${toRem(4)};
    padding: ${toRem(2)} ${toRem(8)};
    font-size: ${toRem(12)};
    font-weight: ${theme.fonts['fontWeightMedium']};
    line-height: 1;
    white-space: nowrap;
    box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.07);

    .a-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      width: ${toRem(16)};
      height: ${toRem(16)};

      .icon-bell::before {
        color: ${baseVariables?.color?.accent30};
        font-size: ${toRem(16)};
        line-height: ${toRem(16)};
      }
    }

    .a-label {
      color: ${baseVariables?.color?.neutral80};
      font-family: 'Swiss721_BT', sans-serif;
      font-weight: 700;
      font-size: ${toRem(12)};
      line-height: 1;
      letter-spacing: 0;
    }
  }
`;
